// Explicit `profiles` column list used in place of `select('*')`.
//
// `push_token` and `push_subscription` are deliberately excluded: they are no longer
// SELECT-able by the anon/authenticated roles (see migration
// 20260708_10_revoke_push_columns_select.sql), so any `select('*')` on `profiles` would
// error and would also expose those device identifiers to other users. Selecting this
// explicit list keeps every field the app already used while leaving the two push
// columns out of client reads. `push_enabled` (a boolean flag) stays available so the
// notification nudge and admin audience count keep working.
//
// Keep this in sync with the `profiles` table if columns are added.
export const PROFILE_COLUMNS =
  'id,username,full_name,avatar_url,bio,role,email_verified,tokens,badge,is_private,' +
  'created_at,updated_at,current_streak,longest_streak,last_brew_date,push_enabled,' +
  'terms_agreed_at,terms_version,shop_id,suspended_at,suspended_reason,' +
  'privacy_accepted_at,privacy_policy_version,deletion_requested_at,is_portal_only,' +
  'team_shop_id,portal_role,verified,welcome_seen_at'
